import React, { useState, FC } from 'react'

import { useParams } from 'react-router'

import { PlatformType } from 'common-constants/bowser'
import { createPhotoViewerUrl } from 'components/page/PhotoViewer/function/createPhotoViewerUrl'
import { PanelBottom } from 'components/page/PhotoViewer/Panel/PanelBottom/PanelBottom'
import { PanelTop } from 'components/page/PhotoViewer/Panel/PanelTop/PanelTop'
import { useCurrentPhotoIndex } from 'components/page/PhotoViewer/PhotoViewer.hooks'
import {
  photoViewerAttachPath,
  PhotoViewerParams,
} from 'components/page/PhotoViewer/PhotoViewer.paths'
import { PhotoViewerCarousel } from 'components/page/PhotoViewer/PhotoViewerCarousel/PhotoViewerCarousel'
import { useLayoutContext } from 'hooks/useLayoutContext'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { usePhotos } from './hooks/usePhotos'

/**
 * Без промки в конце: вам поравилось фото? Подарите подарок.
 * @param isAttachPhotos
 * @constructor
 */
export const PhotoViewerMainWithoutNotice: FC<{
  isAttachPhotos: boolean
}> = ({ isAttachPhotos }) => {
  const { platformType } = useShallowEqualSelector(
    ({ systemReducer: { platformType } }) => ({
      platformType,
    })
  )
  const layoutContext = useLayoutContext()
  const { photoId } = useParams<PhotoViewerParams>()

  const current = useCurrentPhotoIndex()
  const [currentIndex, setCurrentIndex] = useState<number>(current)

  const path = isAttachPhotos ? photoViewerAttachPath : ''
  const baseUrlPhoto = createPhotoViewerUrl(path, layoutContext)

  const { photos } = usePhotos()

  return (
    <>
      <PanelTop
        selectedPhotoIndex={currentIndex}
        isAttachPhotos={isAttachPhotos}
      />
      <PhotoViewerCarousel
        updateCurrentIndex={setCurrentIndex}
        showNotice={false}
        photos={photos}
        photoId={photoId}
        photoBaseUrl={baseUrlPhoto}
        showArrows={platformType !== PlatformType.Mobile && photos.length > 1}
      />
      {!isAttachPhotos && <PanelBottom selectedPhotoIndex={currentIndex} />}
    </>
  )
}
